import {Statistic} from 'antd';
import {useEffect, useRef} from 'react';
import {useRouter} from 'next/router';
import {NoticeBar} from 'antd-mobile';
import useCommon from '@utils/hooks/common';
import PlayerAvatarChipBorder from '@components/PlayerAvatarChipBorder';
import styles from './styles';
// import Poker from '@components/Poker';
// import classnames from 'classnames';

interface WaitListInterface {
  waitList: Array<any>;
}
const mock = [
  {
    id: 1,
    username: '18',
    socketId: 'ThNxLBBfs-h9Z4UpAAAl',
    role: 'OBSERVER',
    totalBetStore: 0,
    totalBet: 0,
  },
  {
    id: 1,
    username: '18',
    socketId: 'ThNxLBBfs-h9Z4UpAAAl',
    role: 'OBSERVER',
    totalBetStore: 0,
    totalBet: 0,
  },
  {
    id: 1,
    username: '18',
    socketId: 'ThNxLBBfs-h9Z4UpAAAl',
    role: 'OBSERVER',
    totalBetStore: 0,
    totalBet: 0,
  },
  {
    id: 1,
    username: '18',
    socketId: 'ThNxLBBfs-h9Z4UpAAAl',
    role: 'OBSERVER',
    totalBetStore: 0,
    totalBet: 0,
  },
];

const WaitList = (props: WaitListInterface): JSX.Element => {
  const {waitList = mock} = props;
  const {classes, t} = useCommon({
    withStyles: styles,
    withTranslation: ['common'],
  });

  return (
    <NoticeBar
      className={classes.noticeBar}
      content={
        <div className={classes.carouselContainer}>
          {Array.isArray(waitList) &&
            waitList.map((waitPlayer, index) => {
              const order = index + 1;
              return (
                <article
                  id={waitPlayer.id}
                  className={classes.individualContainer}
                  key={waitPlayer.id}
                >
                  <PlayerAvatarChipBorder
                    iconWidthPx={35}
                    icon={waitPlayer.icon}
                    className={classes.playerBorder}
                  />
                  {waitPlayer?.displayName} {t('waiting_list_order')}: {order}
                </article>
              );
            })}
        </div>
      }
      icon={null}
    />
  );
};

export default WaitList;
